/**
 * Custom Article Navigation and Scroll Functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  const articleContent = document.getElementById('article-content');
  const navContainer = document.getElementById('article-nav');
  const sidebar = document.getElementById('article-sidebar');

  if (!articleContent || !navContainer) return;

  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 990;
  }

  // Create fixed navigation for mobile
  let fixedNav = null;
  function createFixedNavigation() {
    if (!isMobile()) return;

    // Remove existing fixed nav if it exists
    if (fixedNav) {
      fixedNav.remove();
      fixedNav = null;
    }

    // Clone the navigation
    const originalNav = document.querySelector('.custom-article__navigation');
    if (!originalNav) return;

    fixedNav = originalNav.cloneNode(true);
    fixedNav.classList.add('custom-article__navigation--fixed');
    fixedNav.id = 'fixed-nav';

    // Update the nav container reference for the fixed nav
    const fixedNavContainer = fixedNav.querySelector('.custom-article__nav-links');

    // Add click events to fixed nav links
    const fixedNavLinks = fixedNavContainer.querySelectorAll('.custom-article__nav-link');
    fixedNavLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const offsetTop = targetElement.offsetTop - 80;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });

    document.body.appendChild(fixedNav);
  }

  // Extract all H2 elements from article content
  function extractH2Navigation() {
    const h2Elements = articleContent.querySelectorAll('h2');

    if (h2Elements.length === 0) {
      // Hide navigation if no H2 elements found
      const navSection = document.querySelector('.custom-article__navigation');
      if (navSection) {
        navSection.style.display = 'none';
      }
      return;
    }

    // Clear existing navigation
    navContainer.innerHTML = '';

    // Create navigation links for each H2
    h2Elements.forEach((h2, index) => {
      // Generate unique ID for the H2 if it doesn't have one
      let headingId = h2.id;
      if (!headingId) {
        headingId = 'heading-' + (index + 1);
        h2.id = headingId;
      }

      // Create navigation link
      const navLink = document.createElement('a');
      navLink.href = '#' + headingId;
      navLink.className = 'custom-article__nav-link';
      navLink.textContent = h2.textContent.trim();

      // Add smooth scroll behavior
      navLink.addEventListener('click', function(e) {
        e.preventDefault();
        const targetElement = document.getElementById(headingId);
        if (targetElement) {
          const offsetTop = targetElement.offsetTop - 80; // Account for sticky header
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });

      navContainer.appendChild(navLink);
    });
  }

  // Handle fixed navigation visibility on mobile
  function handleFixedNavigation() {
    if (!isMobile() || !fixedNav || !sidebar) return;

    const sidebarRect = sidebar.getBoundingClientRect();
    const sidebarBottom = sidebarRect.bottom;

    // Show fixed nav when sidebar is scrolled past
    if (sidebarBottom < 0) {
      fixedNav.classList.add('show');
    } else {
      fixedNav.classList.remove('show');
    }
  }

  // Highlight active navigation link based on scroll position
  function highlightActiveNavLink() {
    const h2Elements = articleContent.querySelectorAll('h2');
    const navLinks = navContainer.querySelectorAll('.custom-article__nav-link');

    if (h2Elements.length === 0 || navLinks.length === 0) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let activeIndex = -1;

    // Find the currently visible H2
    h2Elements.forEach((h2, index) => {
      const elementTop = h2.offsetTop - 100;
      if (scrollTop >= elementTop) {
        activeIndex = index;
      }
    });

    // Update active link styling
    navLinks.forEach((link, index) => {
      if (index === activeIndex) {
        link.style.backgroundColor = '#e8f4fd';
        link.style.color = '#1a5bb8';
      } else {
        link.style.backgroundColor = '';
        link.style.color = '#2b72d8';
      }
    });
  }

  // Initialize navigation
  extractH2Navigation();
  createFixedNavigation();

  // Handle scroll events
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    // Use requestAnimationFrame for better performance
    if (scrollTimeout) {
      cancelAnimationFrame(scrollTimeout);
    }

    scrollTimeout = requestAnimationFrame(function() {
      handleFixedNavigation();
      highlightActiveNavLink();
    });
  });

  // Handle resize events
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Recreate fixed navigation on resize
      createFixedNavigation();
      handleFixedNavigation();
    }, 250);
  });

  // Initial setup
  handleFixedNavigation();
  highlightActiveNavLink();
});

/**
 * Utility function to generate slug from text
 */
function generateSlug(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Enhanced scroll to element with offset
 */
function scrollToElement(elementId, offset = 80) {
  const element = document.getElementById(elementId);
  if (!element) return;

  const elementTop = element.offsetTop - offset;
  const start = window.pageYOffset;
  const distance = elementTop - start;
  const duration = 500;
  let startTime = null;

  function animateScroll(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);

    // Easing function (ease-in-out)
    const ease = progress < 0.5
      ? 2 * progress * progress
      : -1 + (4 - 2 * progress) * progress;

    window.scrollTo(0, start + distance * ease);

    if (timeElapsed < duration) {
      requestAnimationFrame(animateScroll);
    }
  }

  requestAnimationFrame(animateScroll);
}